/* eslint-disable */
/* tslint:disable */
// @ts-ignore
export default {
    width: 16,
    height: 16,
    viewBox: '0 0 48 48',
    data: '<path pid="0" d="M10.316 45.686A2.413 2.413 0 0012.727 48h22.546a2.415 2.415 0 002.412-2.314l1.609-33.998H8.706zM29.1 20.133a.98.98 0 01.981-.981h1.569c.542 0 .98.44.98.981v19.422a.98.98 0 01-.98.983h-1.569a.981.981 0 01-.981-.983zm-6.865 0c0-.541.439-.981.981-.981h1.569c.541 0 .981.44.981.981v19.422c0 .543-.44.983-.981.983h-1.569a.982.982 0 01-.981-.983zm-6.866 0c0-.541.44-.981.981-.981h1.569c.542 0 .981.44.981.981v19.422a.982.982 0 01-.981.983H16.35a.982.982 0 01-.981-.983zM40.367 2.472H29.966V.506A.506.506 0 0029.46 0H18.539a.506.506 0 00-.506.506v1.966h-10.4c-.837 0-1.515.68-1.515 1.517l.001 4.762h35.763V3.989c0-.837-.678-1.517-1.515-1.517z"/>'
}
